var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupclose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8335 9.83333L18.1668 18.1667M9.8335 18.1667L18.1668 9.83333",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupclose);
export default __webpack_public_path__ + "static/media/popupclose.55549b608878c72a286b406cfe9c2315.svg";
export { ForwardRef as ReactComponent };